import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../';
import { Data } from '../../helpers';
var ConfirmComponent = /** @class */ (function () {
    function ConfirmComponent(userService, data, router) {
        this.userService = userService;
        this.data = data;
        this.router = router;
        this.user = {};
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        if (this.data.storage == undefined) {
            this.router.navigate(['login']);
        }
        else {
            this.user = this.data.storage.userdata.user;
        }
    }
    ConfirmComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    ConfirmComponent.prototype.ngOnInit = function () {
        console.log(this.user);
    };
    ConfirmComponent.prototype.backToLogin = function () {
        this.router.navigate(['login']);
    };
    ConfirmComponent.prototype.resendEmail = function () {
        var _this = this;
        this.userService.resendEamil(this.user.userDetailsId).subscribe(function (data) {
            console.log(data);
            _this.msgTitle = "Success";
            _this.msgContent = "Mail Sent!!";
            _this.popUp = true;
        }, function (error) {
            _this.msgTitle = "Failed";
            _this.msgContent = "Failed To Send Mail!!";
            _this.popUp = true;
        });
    };
    return ConfirmComponent;
}());
export { ConfirmComponent };
//# sourceMappingURL=confirm.component.js.map